import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ClientTransactionsList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'companyID',
				accessor: 'companyID',
				filterType: FilterType.number
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'clientType',
				accessor: 'clientType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CLIENT_PLANS
			},
			{
				Header: 'transactionType',
				accessor: 'transactionType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.OTO_FEE_TYPE
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.number
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ECOM_TRANSACTION_DESCRIPTIONS,
				renderCell: ListComponents.STRING_ARRAY,
				translate: true
			},
			{
				Header: 'paymentID',
				accessor: 'paymentID',
				filterType: FilterType.number
			},
			{
				Header: 'paidPrice',
				accessor: 'paidPrice',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'amount',
				accessor: 'amount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY_COLORED,
				show: false
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CURRENCY
			},
			{
				Header: 'remainingAmount',
				accessor: 'remainingAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{ Header: 'invoiceId', accessor: 'invoiceId', filterType: FilterType.number, showCopyButton: true },
			{
				Header: 'invoiceNumber',
				accessor: 'invoiceNumber',
				filterType: FilterType.number
			},
			{
				Header: 'invoiceLink',
				accessor: 'invoiceLink',
				width: 110,
				filterType: FilterType.string,
				renderCell: ListComponents.DOWNLOAD_INVOICE,
				showOnMobile: true
			},
			{
				Header: 'transactionDate',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CREDIT_TRANSACTION_STATUS
			},
			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.string
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.number,
				width: 70,
				showCopyButton: true
			}
		],
		[]
	);
	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'transactionDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(7, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[columns]
	);
	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.CLIENT_TRANSACTIONS}
				columns={columns}
				fetchUrl={FINANCE.GET_CLIENT_TRANSACTIONS}
				infiniteScroll
				exportName="clientTransactions"
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				defaultSort={defaultSort}
				defaultFilters={defaultFilters}
			/>
		</TabTableContainer>
	);
};

export default ClientTransactionsList;
